import React from "react";
import { TextField, Theme } from "@material-ui/core";
import { TextFieldProps } from "@material-ui/core/TextField";
import clsx from "clsx";
import { makeStyles, createStyles } from "@material-ui/styles";
import { StyleClassKey } from "js/react/typescript";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {}
    })
);
export type AppTextFieldClassKey = StyleClassKey<typeof useStyles>;
export type AppTextFieldProps = TextFieldProps;

export function AppTextField({ className, ...rest }: AppTextFieldProps) {
    const classes = useStyles(rest);
    return (
        <TextField
            className={clsx(className, classes.root)}
            InputLabelProps={{ shrink: true }}
            {...rest}
            color={"primary"}
            variant={"outlined"}
        />
    );
}

export default AppTextField;
